import { LegalLayout } from '../components/LegalLayout'

export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="2026-10-12">
      <p>
        These Terms govern your use of Prism Factory (the "Service"), a platform that helps creators
        produce, schedule, and publish short videos to third-party platforms such as YouTube, TikTok
        and Instagram using AI-assisted tools.
      </p>

      <h2>1. Acceptance</h2>
      <p>By using the Service, you agree to these Terms. If you do not agree, do not use the Service.</p>

      <h2>2. Accounts</h2>
      <p>
        You are responsible for the credentials you use to authenticate (including OAuth connections to
        third-party platforms) and for all activity under your account.
      </p>

      <h2>3. Your Content</h2>
      <p>
        You retain ownership of any content you upload, generate, or publish through the Service. You
        grant the Service a limited license to process that content solely to provide its features
        (e.g., generating scripts, rendering videos, publishing to platforms you authorized).
      </p>

      <h2>4. Third-Party Platforms</h2>
      <p>
        The Service interacts with third-party APIs (YouTube Data API, TikTok Login Kit and Content
        Posting API, the configured AI provider — Google Gemini API or Anthropic Claude API — and
        others) on your behalf. Use of those platforms is
        governed by their own terms; you are responsible for complying with them, including content
        policies.
      </p>

      <h2>5. Acceptable Use</h2>
      <p>
        You agree not to use the Service to create or publish content that is illegal, infringing,
        deceptive, harassing, or that violates the rules of any platform you publish to. You will not
        attempt to disrupt the Service or access it without authorization.
      </p>

      <h2>6. AI-Generated Content</h2>
      <p>
        The Service uses AI to assist content creation. You are responsible for reviewing AI output
        before publishing and for any consequences of publishing it.
      </p>

      <h2>7. Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate access for violations
        of these Terms or to comply with legal requirements.
      </p>

      <h2>8. Disclaimer</h2>
      <p>
        The Service is provided "as is" without warranties of any kind. We do not guarantee
        uninterrupted operation or specific results from AI-generated content.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, the Service and its operators are not liable for
        indirect, incidental, or consequential damages arising from your use of the Service.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update these Terms. Material changes will be reflected by updating the "Last updated"
        date above. Continued use after changes constitutes acceptance.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms:{' '}
        <a href="mailto:prism.video.factory@gmail.com">prism.video.factory@gmail.com</a>.
      </p>
    </LegalLayout>
  )
}
